/**
 * A text-only brand name card used inside the Trusted-By marquee.
 * Clean, editorial typography. No logo image — deliberately restrained
 * so all brands read at equal visual weight.
 */
export default function LogoCard({ name }) {
  return (
    <div
      data-testid={`logo-card-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="shrink-0 flex items-center justify-center h-24 md:h-28 min-w-[220px] md:min-w-[260px] px-8 border-r border-zinc-200 last:border-r-0"
    >
      <span className="font-serif-display text-2xl md:text-3xl leading-none text-zinc-800 whitespace-nowrap tracking-tight">
        {name}
      </span>
    </div>
  );
}
